import { Dialog, MenuItem } from '@material-ui/core';
import {
  useSuperMutation,
  useSuperQuery,
  useVerifyAction
} from '@vadiun/react-hooks-legacy';
import { WorkingDriverInfo } from 'app/chofer/components/WorkingDriverInfo';
import {
  ChoferTrabajando,
  ChoferTrabajandoExtendedPayload
} from 'app/chofer/models/ChoferTrabajando';
import useChoferes from 'app/chofer/services/ChoferService';
import ViajeTrasladoResumenModal from 'app/viaje/viajeTraslado/viajeTraslado/components/ViajeTrasladoResumenModal';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { useThemeContext } from 'shared/context/themeContext';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';
import ConfirmModal from 'shared/components/ConfirmModal';
import moment from 'moment';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTransferReservationStore } from '../../viajeTraslado/services/TransferReservationSingleStore';
import useViajesTraslado from '../../viajeTraslado/services/ViajeTrasladoService';
import { TransferReservationPendingModel } from '../../pendiente/models/TransferReservationPending';
import { DriverShift } from 'app/chofer/models/DriverShift';
import { TransferReservationManagmentModel } from '../../gestion/models/TransferReservationManagment';
import ViajeTrasladoBaseFilters from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import CancelViajeTrasladoModal from '../../viajeTraslado/components/CancelViajeTrasladoModal';
import { DriverShiftInfo } from 'app/chofer/components/DriverShiftInfo';
import { ViajeTrasladoCoordinarTable } from '../components/ViajeTrasladoCoordinarTable';
import { MonitorDriversInfo } from '../types/Driver';
import { createTableScrollHandler } from 'utils/tableUtils';
import ChoferSearchModal from 'app/chofer/components/ChoferSearchModal';
import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import { ViajeTrasladoTipoServicio } from '../../viajeTraslado/models';
import { useNotificationsContext } from 'shared/context/notificationContext';
import HeaderPage from '../components/HeaderPage';
import BusesPreAssignModal from '../components/buses/pre-assign/BusesPreAssignModal';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import ExtendExcessModal from 'app/chofer/components/ExtendExcessModal';
import DriversNotesModal from '../components/DriversNotesModal';
import {
  useCoordinateReserves,
  columnsLabels,
  getDefaultFilters
} from '../../viajeTraslado/hooks/useCoordinateReserves';
import { CreatedReservationsModal } from '../../viajeTraslado/components/CreatedReservationsModal';
import DriverCanWorkDetails from 'app/chofer/components/DriverCanWorkDetails';
import FiltersDrawer from 'shared/components/filters/FiltersDrawer';
import ChipsBar from 'shared/components/filters/ChipsBar';
import RefreshList from 'shared/components/Table/Refresh';
import SearchList from 'shared/components/Table/Search';
import TableToolbar from 'shared/components/Table/TableToolbar';
import CreateContingencyButton from 'app/contingencies/components/CreateContingencyButton';
import CollapsibleContainer from 'shared/components/CollapsibleContainer';
import ColumnSelector from 'shared/components/Table/actions-buttons/ColumnSelector';
import FiltersButton from 'shared/components/Table/FiltersButton';
import TotalsTrafficLights from 'shared/components/traffic-lights/TotalsTrafficLights';
import { clearStateAndAddFilterColorState } from '../../abierto/utils/openedStorage';

export enum StateActionSelected {
  PRE_ASSIGN = 'PRE-ASSIGN',
  ASSIGN = 'ASSIGN',
  NONE = 'NONE'
}

const ViajeTrasladoCoordinarPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const root = tableRef.current;
    const header = headerRef.current;
    const toolbar = toolbarRef.current;
    if (!root || !header || !toolbar) return;

    const updateStickyOffsets = () => {
      root.style.setProperty(
        '--pending-header-height',
        `${header.getBoundingClientRect().height}px`
      );
      root.style.setProperty(
        '--pending-toolbar-height',
        `${toolbar.getBoundingClientRect().height}px`
      );
    };
    updateStickyOffsets();
    const observer = new ResizeObserver(updateStickyOffsets);
    observer.observe(header);
    observer.observe(toolbar);
    return () => observer.disconnect();
  }, []);
  const history = useHistory();
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  /*
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    Mucho de este componente esta copiado en ViajeTrasladoMapPage.
    Si se hace algun cambio revisar que no se tenga que hacer tambien en ViajeTrasladoMapPage.

    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    */
  const transferReservationHelpers = useTransferReservationStore();

  const ViajeTrasladoService = useViajesTraslado();
  const {
    coordinateReserves,
    reload,
    onFiltersChange,
    onSearchChange,
    filters,
    onChangePage,
    onChangeRowsPerPage,
    onSortChange,
    columnVisibility,
    setColumnVisibility
  } = useCoordinateReserves();

  const {
    getTravelsTaked,
    setDriversRequests,
    setDriversExceededRequests,
    resetCoordinationReloadFlag,
    shouldCoordinationReload,
    refreshTrafficLights
  } = useNotificationsContext();

  const verifyAction = useVerifyAction();

  const driverRepository = useChoferes();

  const [showFilters, setShowFilters] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [closeShiftConfirm, setCloseShiftConfirm] = useState<{
    open: boolean;
    driverId?: number;
  }>({ open: false });

  const [idTravelSelected, setIdTravelSelected] = useState<
    number | undefined
  >();

  const [driverDraftModal, setDriverDraftModal] = useState<{
    isOpen: boolean;
    draft: string;
    reservationId: number;
  }>({ isOpen: false, draft: '', reservationId: 0 });

  const [preAssignDriverOpen, setPreAssignDriverOpen] = useState(false);
  const [assignDriverOpen, setAssignDriverOpen] = useState<{
    isOpen: boolean;
    isContingency: boolean;
  }>({ isOpen: false, isContingency: false });
  const [selectedReservation, setSelectedReservation] = useState<
    TransferReservationPendingModel | undefined
  >(undefined);

  const [isLoadingDrivers, setLoadingDrivers] = useState<boolean>(false);

  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const [isOpenBusesPreAssignModal, setIsOpenBusesPreAssignModal] =
    useState<boolean>(false);

  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);

  const onCloseBusesPreAssignModal = useCallback(() => {
    setIsOpenBusesPreAssignModal(false);
  }, []);

  const preAssignMutation = useSuperMutation(
    ViajeTrasladoService.preAssignDriver,
    { showSpinner: false }
  );

  const assignMutation = useSuperMutation(ViajeTrasladoService.assignDriver, {
    showSpinner: false
  });

  const driversQuery = useSuperQuery(driverRepository.getDriversThatCanWork, {
    showSpinner: false,
    automaticFetch: false
  });

  const [isLoadingDriversCanWork, setIsLoadingDriversCanWork] =
    useState<boolean>(false);
  const [driversCanWork, setDriversCanWork] = useState<ChoferPartialModel[]>(
    []
  );

  const preAssignDriverDraftMutate = useSuperMutation(
    ViajeTrasladoService.preAssignedDriverDraft,
    { showSpinner: true }
  );

  const loadDriversCanWork = async () => {
    setIsLoadingDriversCanWork(true);
    const driversCanWork = await driverRepository.getDriversThatCanWork();
    setDriversCanWork(driversCanWork);
    setIsLoadingDriversCanWork(false);
  };

  useEffect(() => {
    getTravelsTaked();
  }, []);

  useEffect(() => {
    loadDriversCanWork();
  }, []);

  // const preAssignDriver = async (driverId: number) => {
  //   try {
  //     setLoadingAssignOrPreAssignDriver(true);
  //     await preAssignMutation.mutate(idTravelSelected ?? 0, driverId);
  //     setAssignOrPreassignAction(StateActionSelected.NONE);
  //     reload();
  //   } finally {
  //     setLoadingAssignOrPreAssignDriver(false);
  //   }
  // };

  const preAssignDriverByAction = async (driver: ChoferPartialModel) => {
    await preAssignMutation.mutate(selectedReservation!.id, driver.id);
    setPreAssignDriverOpen(false);
    reload();
  };

  const assignDriverByAction = async (
    driver: ChoferPartialModel,
    isContingency: boolean
  ) => {
    await assignMutation.mutate(
      selectedReservation!.id,
      driver.id,
      isContingency
    );
    setAssignDriverOpen({ isOpen: false, isContingency: false });
    driversAmountQuery.reload();
    loadDriversCanWork();
    reload();
  };

  const onRefreshAll = async () => {
    if (isRefreshing) return;
    setIsRefreshing(true);
    try {
      await Promise.all([
        reload(),
        reloadDriverMonitorInfo(),
        onLoadDriversByStatus(),
        refreshTrafficLights()
      ]);
    } finally {
      setIsRefreshing(false);
    }
  };

  const [statusActive, setStatusActive] = useState<string>('FREE');

  const removePreAssignedDriver = async (reservation: number) => {
    await removePreAssignedMutation.mutate(reservation);
    reload();
  };

  // const assignDriver = async (driverId: number) => {
  //   try {
  //     setLoadingAssignOrPreAssignDriver(true);
  //     await assignMutation.mutate(idTravelSelected ?? 0, driverId);
  //     setAssignOrPreassignAction(StateActionSelected.NONE);
  //     driversAmountQuery.reload();
  //     loadDriversCanWork();
  //     reload();
  //   } finally {
  //     setLoadingAssignOrPreAssignDriver(false);
  //   }
  // };

  const savePreAssignedDriverDraft = async (
    draft: string,
    reservationId: number
  ) => {
    try {
      setDriverDraftModal({ isOpen: false, draft: '', reservationId: 0 });
      await preAssignDriverDraftMutate.mutate(reservationId, draft);
      reload();
    } catch (error) {
      console.log(error);
    }
  };

  const startTravel = async (reservation: number, driver: number) => {
    await assignMutation
      .mutate(reservation, driver)
      .catch((e) => console.log(e));
    reload();
  };

  const getOptionsBuses = useCallback(async () => {
    const buses = await ViajeTrasladoService.getOptionsBuses();
    setOptionsBuses(buses);
  }, [ViajeTrasladoService]);

  useEffect(() => {
    getOptionsBuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (assignOrPreassignAction === StateActionSelected.NONE) {
  //     setShowModalAssignOrPreassignDriver(false);
  //     return;
  //   }
  //   setShowModalAssignOrPreassignDriver(true);
  // }, [assignOrPreassignAction]);

  // useEffect(() => {
  //   if (driverSelected === undefined) {
  //     setShowModal(false);
  //     return;
  //   }
  //   setShowModal(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [driverSelected]);

  const [driverDetail, setDriverDetail] = useState<{
    isOpen: boolean;
    details: ChoferTrabajando | undefined;
  }>({ isOpen: false, details: undefined });
  const [driverDetailPreAssign, setDriverDetailPreAssign] = useState<{
    isOpen: boolean;
    details: ChoferPartialModel | undefined;
    busVehicle?: any;
  }>({ isOpen: false, details: undefined });

  const [extendExcessModal, setExtendExcessModal] = useState<{
    isOpen: boolean;
    driverId: number | undefined;
    driverName: string;
    dirverCode: number | undefined;
  }>({
    isOpen: false,
    driverId: undefined,
    driverName: '',
    dirverCode: undefined
  });

  const clearExtendExcessModal = () => {
    setExtendExcessModal({
      isOpen: false,
      driverId: undefined,
      driverName: '',
      dirverCode: undefined
    });
  };

  const [driverShift, setDriverShift] = useState<{
    isOpen: boolean;
    details: DriverShift | undefined;
  }>({ isOpen: false, details: undefined });

  const [reservationDetail, setReservationDetail] = useState<{
    isOpen: boolean;
    details: TransferReservationPendingModel | undefined;
  }>({ isOpen: false, details: undefined });

  const [cancelReservationModal, setCancelReservationModal] = useState<{
    isOpen: boolean;
    reservation: any | undefined;
  }>({ isOpen: false, reservation: undefined });

  const [reservationCopyDetailsModal, setReservationCopyDetailsModal] =
    useState<{
      isOpen: boolean;
      reservation: TransferReservationPendingModel | undefined;
    }>({ isOpen: false, reservation: undefined });

  const driversAmountQuery = useSuperQuery(
    driverRepository.getWorkingDriversAmountPerState,
    {
      showSpinner: false,
      automaticFetch: false
    }
  );

  const removePreAssignedMutation = useSuperMutation(
    ViajeTrasladoService.removePreAssignedDriver,
    { showSpinner: true }
  );

  const closeShiftMutation = useSuperMutation(driverRepository.closeShift, {
    showSpinner: true
  });

  const forceBreakMutation = useSuperMutation(driverRepository.forceBreak, {
    showSpinner: true
  });

  const extendExcessMutation = useSuperMutation(driverRepository.extendExcess, {
    showSpinner: true
  });

  const cancelReservationMutation = useSuperMutation(
    ViajeTrasladoService.cancelReservation,
    { showSpinner: true }
  );

  const approveShiftMutation = useSuperMutation(
    driverRepository.approveShiftClosure,
    { showSpinner: true }
  );
  const denyShiftMutation = useSuperMutation(
    driverRepository.denyShiftClosure,
    { showSpinner: true }
  );

  const notifyDelayMutation = useSuperMutation(
    ViajeTrasladoService.notificarDemora,
    {
      showSpinner: true
    }
  );

  const cancel = async (
    reservationId: number,
    cancelObservation: string,
    cancellationReasonClient: string
  ) => {
    setCancelReservationModal({ reservation: undefined, isOpen: false });
    await cancelReservationMutation.mutate(
      reservationId,
      cancelObservation,
      cancellationReasonClient
    );
    reload();
  };

  const copyReservation = async (
    reservation: TransferReservationManagmentModel
  ) => {
    transferReservationHelpers.copy(reservation.id);
  };

  const closeShift = async (id: number) => {
    await closeShiftMutation.mutate(id);
    await reloadDriverMonitorInfo();
    await onLoadDriversByStatus();
  };

  const forceBreak = async (id: number) => {
    await forceBreakMutation.mutate(id);
    reloadDriverMonitorInfo();
  };

  const extendExcess = async (
    id: number,
    payload: ChoferTrabajandoExtendedPayload
  ) => {
    await extendExcessMutation.mutate(id, payload);
    await reloadDriverMonitorInfo();
    await onLoadDriversByStatus();
  };

  const denyShiftChange = async (id: number) => {
    await denyShiftMutation.mutate(id);
    reloadDriverMonitorInfo();
  };

  const aproveShiftChange = async (id: number) => {
    await approveShiftMutation.mutate(id);
    reloadDriverMonitorInfo();
  };

  const [monitorDriversInfo, setMonitorDriversInfo] =
    useState<MonitorDriversInfo>();

  const [drivers, setDrivers] = useState<ChoferTrabajando[]>([]);

  const onSelectFreeDrivers = useCallback(async () => {
    setLoadingDrivers(true);
    setDrivers(await driverRepository.getWorkingDrivers({ free: true }));
    setLoadingDrivers(false);
  }, [driverRepository]);

  const onSelectBusyDrivers = useCallback(async () => {
    setLoadingDrivers(true);
    setDrivers(await driverRepository.getWorkingDrivers({ busy: true }));
    setLoadingDrivers(false);
  }, [driverRepository]);

  const onSelectUnavailableDrivers = useCallback(async () => {
    setLoadingDrivers(true);
    setDrivers(await driverRepository.getWorkingDrivers({ onBrake: true }));
    setLoadingDrivers(false);
  }, [driverRepository]);

  const onSelectTurnOffDrivers = useCallback(async () => {
    setLoadingDrivers(true);
    setDrivers(
      await driverRepository.getWorkingDrivers({ workdayNotStarted: true })
    );
    setLoadingDrivers(false);
  }, [driverRepository]);

  const onLoadDriversByStatus = async () => {
    if (statusActive === 'FREE') {
      await onSelectFreeDrivers();
    }

    if (statusActive === 'BUSY') {
      await onSelectBusyDrivers();
    }

    if (statusActive === 'UNAVAILABLE') {
      await onSelectUnavailableDrivers();
    }

    if (statusActive === 'ON_BRAKE') {
      await onSelectTurnOffDrivers();
    }
  };

  const reloadDriverMonitorInfo = useCallback(async () => {
    const data = await driverRepository.getWorkingDriversAmountPerState();
    setMonitorDriversInfo(data);
  }, [driverRepository]);

  // const reloadDriverMonitorInfo = useCallback(async () => {
  //   await onLoadMonitorDriversInfo();
  // }, [onLoadMonitorDriversInfo]);

  const hasReloaded = useRef(false);

  useEffect(() => {
    if (coordinateReserves.isLoading) return; // Espera a que termine de cargar
    if (hasReloaded.current) return; // Evita la doble ejecución
    if (monitorDriversInfo) return; // Si ya hay datos, no hace nada

    hasReloaded.current = true; // Marca que ya se ejecutó

    reloadDriverMonitorInfo()
      .then(() => console.log('Carga completada'))
      .catch(() => {
        console.error('Error en reloadDriverMonitorInfo');
        hasReloaded.current = false; // Si falla, vuelve a permitir la ejecución
      });
  }, [coordinateReserves.isLoading]);

  useEffect(() => {
    if (statusActive === '') {
      return;
    }
    onLoadDriversByStatus();
  }, [statusActive]);

  const fetchRequestDrivers = async () => {
    const response = await driverRepository.getShifts({
      driver: undefined,
      openFrom: moment().subtract(1, 'days').hours(0).minutes(0).seconds(0),
      openTo: moment().add(1, 'days').hours(23).minutes(59).seconds(59),
      approval: 'pending'
    });
    setDriversRequests(
      response.data.map((d: DriverShift) => ({
        ...d,
        close_type: d.closeType,
        open_date_time: d.openDateTime,
        open_type: d.openType,
        driver_code: d.driverCode,
        driver_name: d.driverName
      }))
    );
  };

  const fetchExcededShifts = async () => {
    const response = await driverRepository.getExcededShitfts();
    setDriversExceededRequests(
      response.data!.map((d: DriverShift) => ({
        ...d,
        close_type: d.closeType,
        open_date_time: d.openDateTime,
        open_type: d.openType,
        driver_code: d.driverCode,
        driver_name: d.driverName
      }))
    );
  };

  useEffect(() => {
    fetchRequestDrivers();
    fetchExcededShifts();
  }, []);

  return (
    <div
      ref={tableRef}
      className="min-h-screen bg-page-light dark:bg-page-dark"
    >
      <div
        ref={headerRef}
        className="sticky top-0 right-0 left-0 flex flex-col w-full"
        style={{
          zIndex: 101,
          background: 'transparent'
        }}
      >
        <div
          className="flex flex-col w-full"
          style={{
            backdropFilter: 'blur(4px)'
          }}
        >
          <PageHeader
            title="Traslados pendientes"
            toolbar={
              <div className="flex gap-4">
                <TotalsTrafficLights
                  onClick={(filter) => {
                    clearStateAndAddFilterColorState(filter);
                    history.push(`/main/operations/coordination/open-trips`);
                  }}
                />
                <CreateContingencyButton onSuccess={onRefreshAll} />
                <RefreshList
                  onRefreshTable={onRefreshAll}
                  isRefreshing={isRefreshing || coordinateReserves.isLoading}
                  animate={shouldCoordinationReload}
                  stopAnimation={resetCoordinationReloadFlag}
                  size={25}
                />
              </div>
            }
          />
          <CollapsibleContainer
            className=""
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            topExpanded="7px"
            topCollapsed="7px"
            rightExpanded="35px"
            rightCollapsed="0px"
            iconColor={isDark ? darkColors.accent : lightColors.accent}
            iconColorHover={isDark ? darkColors.accent : lightColors.accent}
            backgroundColor={isDark ? darkColors.surface : '#FFFFFF'}
            boxShadow={
              isDark ? darkColors.glow : '0 0 6px rgba(14,165,233,0.4)'
            }
            boxShadowHover={
              isDark
                ? '0 0 12px rgba(34,211,238,0.5)'
                : '0 0 8px rgba(14,165,233,0.6)'
            }
            iconShadowHover={
              isDark
                ? 'drop-shadow(0 0 3px rgba(34,211,238,0.6))'
                : 'drop-shadow(0 0 3px rgba(14,165,233,0.5))'
            }
            buttonSize="32px"
            iconSize="16px"
            maxHeight="500px"
            transitionDuration="0.3s"
            contentClassName="flex justify-between pb-4 md:flex-col lg:flex-col xl:flex-row 2xl:flex-row gap-1 bg-page-light dark:bg-page-dark"
          >
            <HeaderPage
              extendExcess={extendExcess}
              closeShift={closeShift}
              setDriverDetail={setDriverDetail}
              drivers={drivers}
              isLoadingDrivers={isLoadingDrivers}
              monitorDriversInfo={
                monitorDriversInfo ?? {
                  free: 0,
                  busy: 0,
                  onBrake: 0,
                  workdayNotStarted: 0,
                  workdayStarted: 0
                }
              }
              onFilterByStatusDriver={(state) => {
                setStatusActive(state);
              }}
              statusActive={statusActive}
            />
          </CollapsibleContainer>
        </div>
      </div>

      <BusesPreAssignModal
        isOpen={isOpenBusesPreAssignModal}
        travel={selectedReservation}
        optionsBuses={optionsBuses}
        driversQuery={{
          ...driversQuery,
          data: driversCanWork.filter(
            (driver) =>
              driver?.businessUnit?.name ===
              ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES
          ),
          isLoading: isLoadingDriversCanWork
        }}
        handleClose={onCloseBusesPreAssignModal}
        onSuccesPreAssign={() => reload()}
      />

      <ChoferSearchModal
        driversQuery={{
          ...driversQuery,
          data: driversCanWork,
          isLoading: isLoadingDriversCanWork
        }}
        onSelect={(chofer) => {
          setPreAssignDriverOpen(false);
          verifyAction({
            title: '¿Está seguro que desea pre-asignar este viaje?',
            onDeny: () => setPreAssignDriverOpen(false),
            onAccept: () => preAssignDriverByAction(chofer)
          });
        }}
        isOpen={preAssignDriverOpen}
        handleClose={() => setPreAssignDriverOpen(false)}
      />
      <ChoferSearchModal
        driversQuery={{
          ...driversQuery,
          data: driversCanWork,
          isLoading: isLoadingDriversCanWork
        }}
        onSelect={(chofer) => {
          setAssignDriverOpen({ ...assignDriverOpen, isOpen: false });
          verifyAction({
            title: '¿Está seguro que desea asignar este viaje?',
            onDeny: () =>
              setAssignDriverOpen({ ...assignDriverOpen, isOpen: false }),
            onAccept: () =>
              assignDriverByAction(chofer, assignDriverOpen.isContingency)
          });
        }}
        isOpen={assignDriverOpen.isOpen}
        handleClose={() =>
          setAssignDriverOpen({ ...assignDriverOpen, isOpen: false })
        }
      />
      <FiltersDrawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        onClear={() => onFiltersChange(getDefaultFilters())}
      >
        <ViajeTrasladoBaseFilters
          onSubmit={async (filters) => onFiltersChange(filters)}
          initialValues={filters}
          filterByAssignedDriver={false}
          filterByDriverWithCloseShift={false}
          filterByDepartureTimeExceeded={false}
          filterByViolet={false}
          optionsBuses={optionsBuses}
        />
      </FiltersDrawer>

      <PageContainer lessMargin>
        <div className="w-full flex-col gap-4 relative ">
          <div
            ref={toolbarRef}
            className="sticky bg-page-light dark:bg-page-dark"
            style={{ top: 'var(--pending-header-height, 0px)', zIndex: 2 }}
          >
            <TableToolbar
              className="bg-page-light dark:bg-page-dark pt-2"
              chips={
                <ChipsBar
                  filters={filters}
                  onFiltersChange={onFiltersChange}
                  defaultFilters={getDefaultFilters()}
                />
              }
              actions={
                <>
                  <SearchList
                    value={filters.search}
                    onSearch={onSearchChange}
                  />
                  <ColumnSelector
                    columns={columnVisibility}
                    onChange={setColumnVisibility}
                    columnLabels={columnsLabels}
                  />
                  <FiltersButton
                    onClick={() => setShowFilters(true)}
                    isActive={showFilters}
                  />
                </>
              }
            />
          </div>
          <ViajeTrasladoCoordinarTable
            stickyHeaderTop="calc(var(--pending-header-height, 0px) + var(--pending-toolbar-height, 0px))"
            tableQuery={coordinateReserves}
            handlePageChange={createTableScrollHandler(tableRef)}
            idTravelSelected={idTravelSelected}
            setIdTravelSelected={setIdTravelSelected}
            columnVisibility={columnVisibility}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onSortChange={onSortChange}
            onShowDriverDetails={(driver, busVehicle) => {
              setDriverDetailPreAssign({
                isOpen: true,
                details: driversCanWork!.find((d) => d.id === driver.id)!,
                busVehicle
              });
            }}
            onLocationsDetails={(reservation) =>
              setReservationDetail({ isOpen: true, details: reservation })
            }
            onStartTravel={(selectedReservation: number, chofer: number) => {
              verifyAction({
                title: '¿Está seguro que desea abrir este viaje?',
                onAccept: () => startTravel(selectedReservation!, chofer!)
              });
            }}
            onEditReservation={(travel) =>
              transferReservationHelpers.edit(travel.id)
            }
            onReservationCopy={copyReservation}
            onCancelReservation={(
              reservation: TransferReservationPendingModel
            ) => {
              setCancelReservationModal({
                isOpen: true,
                reservation: reservation
              });
            }}
            onReservationShowDetails={(id) => (
              <Link to={'/main/operations/trip-details/' + id}>
                <MenuItem>Ver detalle</MenuItem>
              </Link>
            )}
            onReservationCopyDetails={(
              reservation: TransferReservationPendingModel
            ) => {
              setReservationCopyDetailsModal({
                isOpen: true,
                reservation: reservation
              });
            }}
            onDelayNotify={(reservation) =>
              notifyDelayMutation.mutate(reservation.id)
            }
            onPreAssignDriver={(travel: TransferReservationPendingModel) => {
              setSelectedReservation(travel);
              setPreAssignDriverOpen(true);
            }}
            onRemovePreAssigned={(selectedReservation: number) => {
              verifyAction({
                title: '¿Está seguro que desea remover chofer pre asignado?',
                onAccept: () => removePreAssignedDriver(selectedReservation!)
              });
            }}
            onAssignDriver={(
              travel: TransferReservationPendingModel,
              isContingency: boolean
            ) => {
              setSelectedReservation(travel);
              setAssignDriverOpen({
                isOpen: true,
                isContingency: isContingency
              });
            }}
            onBusesPreAssign={(travel: TransferReservationPendingModel) => {
              setSelectedReservation(travel);
              setIsOpenBusesPreAssignModal(true);
            }}
            onDriverDraft={(draft: string, reservationId: number) => {
              setDriverDraftModal({
                isOpen: true,
                draft: draft,
                reservationId: reservationId
              });
            }}
            isExpanded={isExpanded}
          />
        </div>
      </PageContainer>
      {reservationDetail.details && (
        <ViajeTrasladoResumenModal
          handleClose={() =>
            setReservationDetail({ isOpen: false, details: undefined })
          }
          isOpen={reservationDetail.isOpen}
          reservation={reservationDetail.details}
        />
      )}

      <DriversNotesModal
        driversQuery={{
          ...driversQuery,
          data: driversCanWork,
          isLoading: isLoadingDriversCanWork
        }}
        isOpen={driverDraftModal.isOpen}
        handleClose={() =>
          setDriverDraftModal({ isOpen: false, draft: '', reservationId: 0 })
        }
        onSave={(draft: string) => {
          savePreAssignedDriverDraft(draft, driverDraftModal.reservationId);
        }}
        initialValue={driverDraftModal.draft ?? undefined}
        travelId={driverDraftModal.reservationId}
      />
      <Dialog
        open={driverDetail.isOpen}
        onClose={() => setDriverDetail({ details: undefined, isOpen: false })}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '1rem',
            backgroundImage: isDark
              ? darkColors.pageGradient
              : lightColors.pageGradient,
            backgroundColor: isDark ? darkColors.surface : lightColors.surface
          }
        }}
      >
        {driverDetail.details && (
          <WorkingDriverInfo
            driver={driverDetail.details}
            isOpened={false}
            forceBreak={(id) => {
              setDriverDetail({ details: undefined, isOpen: false });
              forceBreak(id);
            }}
            closeShift={(id) => {
              setDriverDetail({ details: undefined, isOpen: false });
              setCloseShiftConfirm({ open: true, driverId: id });
            }}
            extendExcess={(driver) => {
              setExtendExcessModal({
                isOpen: true,
                driverId: driver.id,
                driverName: driver.name.split('(')[0],
                dirverCode: driver.code
              });
            }}
          />
        )}
      </Dialog>
      <ConfirmModal
        open={closeShiftConfirm.open}
        onClose={() => setCloseShiftConfirm({ open: false })}
        title="Cerrar turno"
        body="¿Está seguro que desea cerrar el turno de este chofer?"
        confirmLabel="Cerrar turno"
        onConfirm={() => {
          if (closeShiftConfirm.driverId !== undefined) {
            closeShift(closeShiftConfirm.driverId);
          }
          setCloseShiftConfirm({ open: false });
        }}
      />
      <Dialog
        open={driverDetailPreAssign.isOpen}
        onClose={() =>
          setDriverDetailPreAssign({ details: undefined, isOpen: false })
        }
        maxWidth="md"
      >
        {driverDetailPreAssign.details && (
          <DriverCanWorkDetails
            driver={driverDetailPreAssign.details}
            busVehicle={driverDetailPreAssign.busVehicle}
          />
        )}
      </Dialog>
      <Dialog
        open={extendExcessModal.isOpen}
        onClose={clearExtendExcessModal}
        maxWidth="md"
      >
        {extendExcessModal.driverId && (
          <ExtendExcessModal
            driver={{
              id: extendExcessModal.driverId,
              name: extendExcessModal.driverName,
              code: extendExcessModal.dirverCode
            }}
            onSubmit={async (payload: ChoferTrabajandoExtendedPayload) => {
              await extendExcess(extendExcessModal.driverId!, payload);
              clearExtendExcessModal();
              setDriversExceededRequests([]);
            }}
            onCancel={clearExtendExcessModal}
          />
        )}
      </Dialog>
      <CancelViajeTrasladoModal
        isOpen={cancelReservationModal.isOpen}
        onClose={() =>
          setCancelReservationModal({
            reservation: undefined,
            isOpen: false
          })
        }
        cancel={cancel}
        reservation={cancelReservationModal.reservation!}
      />
      <Dialog
        open={driverShift.isOpen}
        onClose={() => setDriverShift({ details: undefined, isOpen: false })}
        maxWidth="sm"
      >
        {driverShift.details && (
          <DriverShiftInfo
            driverShift={driverShift.details}
            deny={(id) => {
              setDriverShift({ details: undefined, isOpen: false });
              verifyAction({
                onAccept: () => denyShiftChange(id),
                body: '¿Está seguro que desea rechazar esta solicitud?'
              });
            }}
            approve={(id) => {
              setDriverShift({ details: undefined, isOpen: false });
              verifyAction({
                onAccept: () => aproveShiftChange(id),
                body: '¿Está seguro que desea aprobar esta solicitud?'
              });
            }}
          />
        )}
      </Dialog>

      {reservationCopyDetailsModal.isOpen && (
        <CreatedReservationsModal
          open={reservationCopyDetailsModal.isOpen}
          reservationsData={[reservationCopyDetailsModal.reservation!]}
          onCancel={() =>
            setReservationCopyDetailsModal({
              isOpen: false,
              reservation: undefined
            })
          }
        />
      )}
    </div>
  );
};

export default ViajeTrasladoCoordinarPage;
